<template>
  <div></div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

import { useAuthStore } from '@/store/auth'
import { useConfigStore } from '@/store/config'
import sync from '@/sync/service'

const authStore = useAuthStore()
const configStore = useConfigStore()
const router = useRouter()

onMounted(async () => {
  await authStore.getDemoAuthData()
  configStore.activateDemoMode()
  sync.resync()
  router.push({ name: 'employees' })
})
</script>
